import React from 'react';
import { Skeleton } from '@mui/material';
import styled from 'styled-components';

const SkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 2rem;
  border-bottom: 1px solid #eeeeee;

  div {
    margin-right: 5%;
  }
`;

export const SkeletonLine = () => (
  <>
    <SkeletonContainer>
      <Skeleton height={20} variant="rectangular" width="25%" />
      <Skeleton height={20} variant="rectangular" width="25%" />
      <Skeleton height={20} variant="rectangular" width="25%" />
      <Skeleton height={20} variant="rectangular" width="25%" />
    </SkeletonContainer>
    <SkeletonContainer>
      <Skeleton height={20} variant="rectangular" width="25%" />
      <Skeleton height={20} variant="rectangular" width="25%" />
      <Skeleton height={20} variant="rectangular" width="25%" />
      <Skeleton height={20} variant="rectangular" width="25%" />
    </SkeletonContainer>
  </>
);
